export const NAV = {
  logo: "navbar-logo",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkProducts: "nav-link-products",
  linkContact: "nav-link-contact",
  whatsappCta: "nav-whatsapp-cta",
  mobileMenuBtn: "nav-mobile-menu-btn",
  mobileHome: "mobile-nav-home",
  mobileAbout: "mobile-nav-about",
  mobileProducts: "mobile-nav-products",
  mobileContact: "mobile-nav-contact",
};

export const HOME = {
  emergentLink: "home-emergent-link",
  heroSection: "hero-section",
  heroHeadline: "hero-headline",
  heroCtaProducts: "hero-cta-products",
  heroCtaWhatsapp: "hero-cta-whatsapp",
  categoriesSection: "categories-section",
  categoryCard: "category-card",
  statsSection: "stats-section",
  whySection: "why-section",
  ctaBanner: "cta-banner",
};

export const PRODUCTS = {
  pageSection: "products-page-section",
  categoryFilter: "category-filter",
  categoryTab: "category-tab",
  productGrid: "product-grid",
  inquiryBtn: "inquiry-whatsapp-btn",
};

export const ABOUT = {
  pageSection: "about-page-section",
  storySection: "about-story-section",
  teamSection: "about-team-section",
};

export const CONTACT = {
  pageSection: "contact-page-section",
  formName: "contact-form-name",
  formPhone: "contact-form-phone",
  formProduct: "contact-form-product",
  formMessage: "contact-form-message",
  formSubmit: "contact-form-submit",
};

export const WHATSAPP = {
  floatingBtn: "whatsapp-floating-button",
};
